import Raven from 'raven-js';
import { hubsSettingClient } from '../../client/hubsSettingsClient';
import { InMemoryCache } from '../InMemoryCache';
const fetchSetting = ({
  settingName,
  defaultValue
}, client) => {
  return hubsSettingClient.withHttpClient(client).fetch(settingName, defaultValue).catch(err => {
    Raven.captureException(err);
    return defaultValue;
  });
};
export const makeHubsSettingsCache = () => new InMemoryCache('HubsSettingsCache', ({
  settingName
}) => settingName, ({
  httpClient
}) => key => fetchSetting(key, httpClient));